<mat-expansion-panel class="mat-elevation-z0 second-menu" *ngFor="let item of children; let i = index">
    <mat-expansion-panel-header *ngIf="item.children">
        <mat-panel-title><i class="{{item.icons}} icons"></i> {{item.name}}</mat-panel-title>
    </mat-expansion-panel-header>
    <mat-nav-list *ngFor="let secondItem of item.children; let i = index">
        <a mat-list-item routerLink="{{secondItem.path}}" *ngIf="!secondItem.children"
            [routerLinkActive]="['navigation-active']" [routerLinkActiveOptions]="{exact: true}">{{secondItem.name}}</a>
    </mat-nav-list>
    <app-sidemenu [children]="item.children"></app-sidemenu>
</mat-expansion-panel>